import { TableRowObject, TableCellObject } from 'components';

export const colTypes = ['propName', 'type']; // col type is mapped by index

function getColType(index: number): string {
	return colTypes[index];
}

const getDataItem = (item: object | string, type: string, index: number): TableCellObject => {
	const components: { [index: string]: string } = {
		rows: 'props-table-cell-body',
		cols: 'props-table-cell-head'
	};

	if (typeof item === 'string') {
		return {
			text: item,
			component: components[type],
			colType: getColType(index)
		};
	}

	return <TableCellObject>{
		...item,
		component: components[type],
		colType: getColType(index)
	};
};

const fillUsetedPosition = (array: Array<object | string>, finalLength: number, filler: string = ''): Array<object | string> => {
	if (array.length < finalLength) {
		return [...array, ...new Array(finalLength - array.length).fill(filler)];
	}

	return array;
};

/**
 * rows: ["row1", "row2", "row3"]
 * rows { data: [], payload: {} }
 * @param data
 * @param currentKey
 */
export const processData = (row: TableRowObject | Array<TableRowObject>, type: string, rowLength: number): any => {
	if (typeof row === 'object' && (<TableRowObject>row).data) {
		const procesedArray = processData(<Array<TableRowObject>>(<TableRowObject>row).data, type, rowLength);

		return {
			...row,
			data: fillUsetedPosition(procesedArray, rowLength)
		};
	}

	return (<Array<TableRowObject>>row).map((item: TableRowObject, index: number) => {
		if (Array.isArray(item) || (typeof item === 'object' && item.data)) {
			return processData(item, type, rowLength);
		}

		return getDataItem(item, type, index);
	});
};
